import React from 'react'

const storeContext = React.createContext()

export default storeContext
